import { Component, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { SsspModel } from 'src/app/models/sssp-model';
import { ApiRequestService } from 'src/app/shared/api-request.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { RBACService } from 'src/app/shared/rbac.service';
import { SsspSnapshotsComponent } from '../sssp-snapshots/sssp-snapshots.component';

@Component({
    selector: 'app-sssp-tabs',
    templateUrl: './sssp-tabs.component.html',
    styleUrls: ['./sssp-tabs.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SsspTabsComponent implements OnInit {

  @Input('sssp_hash') sssp_hash: string;

  sssp: SsspModel = new SsspModel();

  public dialogRef: any; // Add this to prevent --aot build from failing due to non-existent ref.

  @ViewChild('ssspSnapshotsComponent') ssspSnapshotsComponent: SsspSnapshotsComponent;

  constructor(
    public app: AppService,
    public api: ApiRequestService,
    public utils: UtilsService,
    public rbac: RBACService
  ) { }

  ngOnInit() {
    this.getSSSP();
  }

  getSSSP() {
    return this.api.makeRequest('get', `v1/sssp/${this.sssp_hash}`)
    .then((response) => {
      this.sssp.apply(response);
    })
    .catch((errorResponse) => {
      this.utils.showModal('Error', errorResponse.error.message);
    });
  }

  onTabChanged(tabData) {
    if ( tabData.index == 2 ) {
      // Reload the list data in the snapshots tab (respect the child's RBAC guard).
      if ( this.ssspSnapshotsComponent?.hasPermission ) {
        this.ssspSnapshotsComponent.listDataSource.getData();
      }
    }
  }

  /**
   * Check if user can create safety plans from any perspective (needed for documents tab)
   */
  canCreateSafetyPlans(): boolean {
    return this.rbac.userCanAccess([
      RBACService.getPermission(RBACService.RBAC_F.F_SITES_SAFETY_PLANS, RBACService.RBAC_A.A_CREATE),
      RBACService.getPermission(RBACService.RBAC_F.F_CONTRACTORS_SAFETY_PLANS, RBACService.RBAC_A.A_CREATE),
      RBACService.getPermission(RBACService.RBAC_F.F_CLIENT_SITES, RBACService.RBAC_A.A_EDIT)
    ]);
  }

  /**
   * Check if user can edit safety plans from any perspective
   */
  canEditSafetyPlans(): boolean {
    return this.rbac.userCanAccess([
      RBACService.getPermission(RBACService.RBAC_F.F_SITES_SAFETY_PLANS, RBACService.RBAC_A.A_EDIT),
      RBACService.getPermission(RBACService.RBAC_F.F_CONTRACTORS_SAFETY_PLANS, RBACService.RBAC_A.A_EDIT),
      RBACService.getPermission(RBACService.RBAC_F.F_SAFETY_PLANS, RBACService.RBAC_A.A_EDIT),
      RBACService.getPermission(RBACService.RBAC_F.F_CLIENT_SITES, RBACService.RBAC_A.A_EDIT)
    ]);
  }
}
